import { render } from "./CompleteColonoscopyOverlay.vue?vue&type=template&id=4d53b492&lang=pug"
import script from "./CompleteColonoscopyOverlay.vue?vue&type=script&lang=js"
export * from "./CompleteColonoscopyOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__